module.exports = __webpack_public_path__ + "img/iStock-1303806337.dc7993d9.webp";